import axios from "axios";
import { useEffect, useState } from "react";
import ItemCard from "../../components/ItemCard";
import YoutubeEmbed from "../../components/YoutubeEmbed";
import ProgressBar from "../../components/ProgressBar";
import Header from "../../components/Header";

export default function ViewProject() {
  const [items, setItems] = useState([]);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [videosDetail, setVideosDetail] = useState({
    completedVideos: 0,
    totalvideos: 0,
  });
  const pathURL = window.location.href.split("/");
  const [projectId, setProjectId] = useState(pathURL[pathURL.length - 1]);
  const [noteForm, setNoteForm] = useState({
    notes: "",
  });
  useEffect(() => {
    const getData = async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_URL}/api/v1/dashboard/view-project/${projectId}`
      );
      setItems(res.data.project.videos);
      setVideosDetail({
        completedVideos: res.data.project.completedVideos,
        totalvideos: res.data.project.totalvideos,
      });
      setNoteForm({ notes: res.data.project.videos[currentVideoIndex].notes });
    };
    getData();
  }, []);
  const handleChange = async (_id) => {
    const updatedItems = items.map((item) =>
      item._id === _id ? { ...item, isCompleted: !item.isCompleted } : item
    );
    setItems(updatedItems);
    const res = await axios.post(
      `${process.env.REACT_APP_URL}/api/v1/dashboard/view-project/${projectId}`,
      updatedItems
    );
    setVideosDetail({
      completedVideos: res.data.project.completedVideos,
      totalvideos: res.data.project.totalvideos,
    });
  };
  const handleClick = async (index) => {
    setCurrentVideoIndex(index);
    setNoteForm({ notes: items[index].notes });
  };
  const handleNotesChange = async (event) => {
    setNoteForm({ notes: event.target.value });
    const res = await axios.patch(
      `${process.env.REACT_APP_URL}/api/v1/dashboard/${projectId}/${currentVideoIndex}`,
      { notes: event.target.value }
    );
    setItems(res.data.project.videos);
  };
  return (
    <div className="w-full h-full">
      <Header />
      <div className="grid grid-cols-3 h-full">
        <div className="col-span-2 border-r-4 p-2 overflow-y-auto mycustom-scroll ">
          <div className="h-fit">
            {items.length && (
              <YoutubeEmbed embedId={items[currentVideoIndex].videolink} />
            )}
          </div>
          <div className="bg-gray-300 mt-2">
            <h1 className="text-3xl font-semibold p-2">NOTES</h1>
            <form className="h-96 bg-gray-500 font-xl">
              <textarea
                name="notes"
                className="textarea-custom"
                onChange={handleNotesChange}
                value={noteForm.notes}
              />
            </form>
          </div>
        </div>
        <div className="overflow-y-auto bg-gray-200 mycustom-scroll">
          <div className="h-12">
            <ProgressBar
              completed={videosDetail.completedVideos}
              total={videosDetail.totalvideos}
            />
          </div>

          <ul>
            {items.map((item, index) => (
              <ItemCard
                key={item._id}
                item={item}
                handleChange={handleChange}
                handleClick={handleClick}
                index={index}
                currentVideoIndex={currentVideoIndex}
              />
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
